import { formPageSlugs } from "Data";
import emoji from "Assets/emoji/book.svg";
import styles from "Styles/StartPage.module.css";
import { StartButton } from "Components/StartButton/StartButton";
import { useEffect, useState } from "react";
import useBackgroundUpdate from "Hooks/useBackgroundUpdate";
import useSessionNavigate from "Hooks/useSessionNavigate";
import { useProgress } from "Contexts/ProgressContext";
import { useSession } from "Contexts/SessionContext";
import useSegment from "Hooks/useSegment";
import { getResumePageFromSession } from "Lib/session-restore-utils";

export default function StartPage() {
  const { currentPage, changePage } = useProgress();
  const segment = useSegment();
  const { sessionNavigate } = useSessionNavigate();
  const { sessionData, sessionCode, isLoading } = useSession();
  const [hasCheckedSession, setHasCheckedSession] = useState(false);

  useEffect(() => {
    if (currentPage === null) return;
    changePage(segment);
  }, [segment, changePage, currentPage]);

  useEffect(() => {
    if (isLoading || hasCheckedSession) return;

    if (sessionCode && sessionData) {
      if (sessionData.status === "completed") {
        sessionNavigate("/complete", { replace: true });
      } else {
        const resumePage = getResumePageFromSession(sessionData.current_page);
        sessionNavigate(`/form/${resumePage}`, { replace: true });
      }
    }

    setHasCheckedSession(true);
  }, [sessionCode, sessionData, isLoading, hasCheckedSession, sessionNavigate]);

  useBackgroundUpdate("fullwidth");

  return (
    <div className={styles.wrapper}>
      <div className={styles.mainContent}>
        <div className={styles.descriptionWrapper}>
          <p className={styles.description}>
            10分鐘行銷現況健檢，幫你釐清行銷資源配置優先順序，立即領取客製化診斷報告，找到最值得投入的方向！
          </p>
        </div>
        <div className={styles.headlineWrapper}>
          <div className={styles.emojiWrapper}>
            <img className={styles.emoji} src={emoji} alt="clap emoji" />
          </div>
          <h1 className={styles.headline}>
            10 分鐘領取
            <br />
            行銷現況診斷報告
          </h1>
          <p className={styles.subHeadline}>準確佈局年度行銷計劃</p>
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        <StartButton
          label="立即開始"
          linkTarget={`/form/${formPageSlugs[0]}`}
        />
      </div>
    </div>
  );
}
